<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M11.125 5.49995L12.6894 3.93562C13.2751 3.34983 14.2249 3.34983 14.8106 3.93561L16.0644 5.1893C16.6501 5.77508 16.6501 6.72483 16.0644 7.31062L14.5 8.87492M11.125 5.49995L3.46967 13.1553C3.32902 13.2959 3.25 13.4867 3.25 13.6856V16.7499H6.31434C6.51325 16.7499 6.70402 16.6709 6.84467 16.5303L14.5 8.87492M11.125 5.49995L14.5 8.87492" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'EditIconV2',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>